export const productPlaceholderSmallImage = {
  path: "/assets/images/product-placeholder.webp",
};

export const productPlaceholderlargeImage = {
  path: "/assets/images/product-placeholder-lg.webp",
};
